import { BASE_URL_BACKEND } from "@/constants"
import { ProviderInstance, ProviderInstanceLabel, ProviderInstanceShortLabel, RegionInstanceLabel } from "@/service/one-click-deploy/type"

export const fNameRegion = (region: string | undefined) => {
  if(!region) return region
  if(!RegionInstanceLabel?.[region]) return region
  return `${RegionInstanceLabel?.[region]} (${region})`
}

export const fNameProvider= (provider: string | undefined) => {
  if(!provider) return provider
  const label = provider.toLocaleLowerCase() as ProviderInstance
  if(!ProviderInstanceLabel?.[label]) return provider
  return ProviderInstanceLabel?.[label]
}

export const fNameProviderShort= (provider: string | undefined) => {
  if(!provider) return provider
  const label = provider.toLocaleLowerCase() as ProviderInstance
  if(!ProviderInstanceShortLabel?.[label]) return provider
  return ProviderInstanceShortLabel?.[label]
}

export const fShortProjectId = (projectId: string) => {
  return projectId.slice(0, 8) + '...';
};

export const fEndpointServerless = (endpoint: string) => {
  const url = BASE_URL_BACKEND.replace(/\/+$/, ''); // Remove trailing slashes
  return {
    all: `${url}/task/run/<function|server>/${endpoint}`,
    function: `${url}/task/run/function/${endpoint}`, 
    server: `${url}/task/run/server/${endpoint}`,
  };
};

export const fTokenServerless = (token: string) => {
  return token.slice(0, 11) + '************' + token.slice(-8);
};
